<template>
  <div class="connection-inform" v-if="isShowConnectionInform">
    <div class="connection-inform__body" :class="{'no-internet': isNoInternet}">
      <div class="connection-inform__container">
        <div class="connection-inform__text">
          {{ message }}
        </div>
        <div class="connection-inform__action">
          <div class="action-reload" @click="reloadPage">
            <button class="rm-outline">
              {{ $t("Reload") }}
            </button>
          </div>
          <div class="line" />
          <div class="action-close" @click="close">
            <button class="rm-outline">
              <aha-icon
                name="close"
                width="16"
                viewBox="0 0 24 24"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Util from '@/util'
import { CONNECTION_STATUS } from '@/utils/system/SystemConnection'

export default {
  computed: {
    ...mapGetters('systemConnection', [
      'connectionStatus',
      'userConnectionStatus',
      'showConnectionInform',
      'emqxStatus',
    ]),
    ...mapGetters('featureToggles', ['canUseNewChangeSlideMechanism']),
    isEmqxNotConnected() {
      return [CONNECTION_STATUS.ERROR, CONNECTION_STATUS.RECONNECTING].includes(this.emqxStatus)
    },
    isNoInternet() {
      if (this.canUseNewChangeSlideMechanism && this.isEmqxNotConnected) {
        return true
      }
      return this.userConnectionStatus === CONNECTION_STATUS.ERROR
    },
    isShowConnectionInform() {
      return this.showConnectionInform && (
        this.userConnectionStatus === CONNECTION_STATUS.RECONNECTING
        || this.userConnectionStatus === CONNECTION_STATUS.ERROR
        || (this.canUseNewChangeSlideMechanism && this.isEmqxNotConnected)
      )
    },
    message() {
      if (this.canUseNewChangeSlideMechanism && this.isEmqxNotConnected) {
        return this.$t('No internet. Retrying...')
      }
      if (this.userConnectionStatus) {
        return this.$t('No internet. Retrying...')
      }
      return ''
    },
  },
  methods: {
    ...mapActions('systemConnection', ['setShowConnectionInform']),
    reloadPage() {
      window.location.reload()
      Util.mixpanelTrack(
        'System Status',
        'User presses Reload',
        this.$store.state.presentation.id,
        { nonInteraction: true },
      )
    },
    close() {
      this.setShowConnectionInform(false)
    },
  },
}
</script>

<style lang="scss" scoped>
.connection-inform {
  color: #000;
  height: 76px;
  .connection-inform__body {
    z-index: 20;
    position: fixed;
    width: 100%;
    top: 0;

    &.no-internet {
      background-color: #F2F7FF;
    }
  }

  .connection-inform__container {
    max-width: 710px;
    height: 76px;
    margin: auto;
    padding: 4px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .connection-inform__text {
      padding-left: 16px;
    }
    .connection-inform__action {
      display: flex;
      justify-content: center;
      align-items: center;

      .rm-outline {
        background-color: transparent;
        display: flex;
        border: none;
        cursor: pointer;
      }
      .line {
        width: 2px;
        height: 20px;
        background-color: #D3D7E1;
      }
    }
    .action-reload {
      cursor: pointer;
      font-weight: bold;
      padding: 0 10px;

      button {
        padding: 15px 6px;
        border-radius: 20px;
        min-width: 60px;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          color: theme('colors.primary.90');
        }
        &:active {
          color: #1162C0;
          outline-color: #89BEFA;
        }
        &:focus-visible {
          outline-color: #89BEFA;
        }
      }
    }
    .action-close {
      padding: 3px 18px;
      cursor: pointer;
      display: flex;
      align-items: center;

      button {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100%;

        &:focus-visible {
          outline-color: #89BEFA;
        }
      }
      svg {
        &:hover {
          color: theme('colors.primary.90');
        }
        &:active {
          color: #1162C0;
        }
      }
    }
  }
}
</style>
